export type NotificacaoTipo = 'novo_pedido' | 'novo_orcamento' | 'orcamento_aceite';

export interface NotificacaoDados {
  solicitacao_id?: string;
  orcamento_id?: string;
  cliente_id?: string;
  empresa_nome?: string;
  valor?: number;
  primeiro_nome?: string;
  categoria?: string;
  cidade?: string;
}

/** Deriva a rota de destino ao clicar numa notificação. */
export function notificacaoLink(tipo: NotificacaoTipo, dados: NotificacaoDados, isConsumer: boolean): string {
  switch (tipo) {
    case 'novo_pedido':
      return '/solicitacoes';
    case 'novo_orcamento':
      return `/app/pedidos/${dados.solicitacao_id ?? ''}`;
    case 'orcamento_aceite':
      return `/painel?cliente=${dados.cliente_id ?? ''}`;
  }
}

export interface NotificacaoTextoResult {
  key: string;
  vars: Record<string, string | number>;
}

/** Mapeia o tipo+dados para a chave i18n e as variáveis de interpolação. */
export function notificacaoTexto(tipo: NotificacaoTipo, dados: NotificacaoDados): NotificacaoTextoResult {
  switch (tipo) {
    case 'novo_pedido':
      return {
        key: 'notifications.items.novo_pedido',
        vars: { nome: dados.primeiro_nome ?? '', categoria: dados.categoria ?? '', cidade: dados.cidade ?? '' },
      };
    case 'novo_orcamento':
      return {
        key: 'notifications.items.novo_orcamento',
        vars: { empresa: dados.empresa_nome ?? '', valor: dados.valor ?? 0 },
      };
    case 'orcamento_aceite':
      return {
        key: 'notifications.items.orcamento_aceite',
        vars: { nome: dados.primeiro_nome ?? '' },
      };
  }
}
